import { useEffect } from "react";
import { useDepartments } from "@/api/queries/departments";
import { useAppStore } from "@/store/app-store";
import { trackEvent, AnalyticsEvent } from "@/analytics";

export function DepartmentSwitcher() {
  const { data } = useDepartments();
  const selected = useAppStore((s) => s.selectedDepartmentId);
  const setSelected = useAppStore((s) => s.setSelectedDepartmentId);

  useEffect(() => {
    if (!data || data.length === 0) return;
    // Auto-select the first department when nothing is chosen, and self-heal
    // if the stored selection no longer matches a known department. "all" is a
    // valid sentinel (All departments), so it is left untouched.
    const isValid = selected === "all" || data.some((d) => d.id === selected);
    if (!isValid) {
      setSelected(data[0]!.id);
    }
  }, [data, selected, setSelected]);

  if (!data || data.length === 0) return null;
  return (
    <select
      className="h-9 rounded-md border border-input bg-background px-2 text-sm"
      value={selected ?? ""}
      onChange={(e) => {
        const value = e.target.value || null;
        setSelected(value);
        // Record only the breadth of the view (all-departments vs a single
        // department), never which tenant — keeps department ids out of analytics.
        trackEvent(AnalyticsEvent.DepartmentSwitched, {
          scope: value === "all" ? "all" : "single",
        });
      }}
      aria-label="Department"
    >
      <option value="" disabled>
        Select department…
      </option>
      <option value="all">All departments</option>
      {data.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  );
}
